'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endLoadingMiddleware = exports.startLoadingMiddleware = exports.promiseMiddleWare = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @Author: Paco
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @Date: 2018-11-26 21:44:18
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @LastEditTIme: Paco
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @Description:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _prefixNameSpace = require('./prefixNameSpace');

var _prefixNameSpace2 = _interopRequireDefault(_prefixNameSpace);

var _promiseMiddleware = require('./middlewares/promiseMiddleware');

var _promiseMiddleware2 = _interopRequireDefault(_promiseMiddleware);

var _loadingMiddleWare = require('./middlewares/loadingMiddleWare');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeedRedux = function () {
  function FeedRedux() {
    var _this = this;

    var model = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      middlewares: [],
      initReducer: {}
    };

    _classCallCheck(this, FeedRedux);

    this.useSelector = _reactRedux.useSelector;


    // Model链接规则
    this.NAMESPACE_SEP = '/';

    // Model中间件
    this.middlewares = props.middlewares.concat(FeedRedux.defaultProps.middlewares);

    // 默认reducer
    this.initReducer = Object.assign({}, props.initReducer);

    // 沙盒Model
    this._models = model.map(function (item) {
      return (0, _prefixNameSpace2.default)(item, _this.NAMESPACE_SEP);
    });

    // reducer
    this._reducer = this.createReducer(this._models);

    // redux store
    this._store = this.createStore();

    // redux actions
    this._actions = this.createActions(this._models);
  }

  /**
   * 绑定actions
   * @param selector
   * @returns {*}
   */


  /**
   * 默认内置的 redux middleware
   */


  _createClass(FeedRedux, [{
    key: 'createBindActions',
    value: function createBindActions(selector) {
      var dispatch = (0, _reactRedux.useDispatch)();
      var selected = selector(this._actions);
      // 接受函数绑定
      if (typeof selected === 'function') {
        return (0, _redux.bindActionCreators)(selected, dispatch);
      }
      // 接受对象绑定
      var keys = Object.keys(selected);
      for (var i = 0; i < keys.length; i++) {
        var item = keys[i];
        if (typeof selected[item] === 'function') {
          selected = (0, _redux.bindActionCreators)(selected, dispatch);
          break;
        } else {
          // 接受多级对象绑定
          selected[item] = (0, _redux.bindActionCreators)(selected[item], dispatch);
        }
      }
      return selected;
    }

    /**
     * 集合actions
     */

  }, {
    key: 'createActions',
    value: function createActions(model) {
      return model.reduce(function (actions, item) {
        actions[item.namespace] = item.actions;
        return actions;
      }, {});
    }

    /**
     * 通过handler获取reducer
     * @param initialState
     * @param handlers
     * @returns {function(...[*]=)}
     */

  }, {
    key: 'createReducer',


    /**
     * 初始化Reducer
     * @param model
     * @returns {*}
     */
    value: function createReducer(model) {
      var reducer = {};
      model.forEach(function (item) {
        reducer[item.namespace] = FeedRedux.getReducer(item.state, item.reducers);
      });

      return (0, _redux.combineReducers)(_extends({}, reducer, this.initReducer));
    }
  }, {
    key: 'createStore',


    /**
     * 初始化store
     * @returns {*}
     */
    value: function createStore() {
      return FeedRedux.createStore({
        reducers: this._reducer,
        middleWares: this.middlewares
      });
    }

    /**
     * 动态新增model
     * @param model
     * TODO 动态添加Model并替换
     */

  }, {
    key: 'addModel',
    value: function addModel(model) {}

    /**
     * 获取Redux  Provider
     * @returns {function({children: *}): *}
     */

  }, {
    key: 'getProvider',
    value: function getProvider() {
      var _this2 = this;

      return function (_ref) {
        var children = _ref.children;

        return _react2.default.createElement(
          _reactRedux.Provider,
          { store: _this2._store },
          children
        );
      };
    }
  }], [{
    key: 'getReducer',
    value: function getReducer(initialState, handlers) {
      return function (state) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (state === undefined) {
          state = initialState;
        }
        var typeAyy = action.type ? action.type.split('/') : [];
        var type = typeAyy.length > 2 ? typeAyy.slice(0, 2).join('/') : action.type;
        var handler = type ? handlers[type] : undefined;
        if (!handler) {
          return state;
        }
        return handler(state, action);
      };
    }

    /**
     * 获取store
     * @param reducers
     * @param initState
     * @param middleWares
     * @returns {*}
     */

  }, {
    key: 'createStore',
    value: function createStore(_ref2) {
      var reducers = _ref2.reducers,
          _ref2$initState = _ref2.initState,
          initState = _ref2$initState === undefined ? window.__initState__ || {} : _ref2$initState,
          middleWares = _ref2.middleWares;

      var composeEnhancers = _redux.compose;
      if (process.env.NODE_ENV === 'development') {
        /* eslint-disable no-underscore-dangle */
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
        /* eslint-enable */
      }
      return (0, _redux.createStore)(reducers, initState, composeEnhancers(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middleWares))));
    }
  }]);

  return FeedRedux;
}();

FeedRedux.defaultProps = {
  middlewares: [_reduxThunk2.default, _loadingMiddleWare.startLoadingMiddleware, _promiseMiddleware2.default, _loadingMiddleWare.endLoadingMiddleware]
};
exports.default = FeedRedux;
exports.promiseMiddleWare = _promiseMiddleware2.default;
exports.startLoadingMiddleware = _loadingMiddleWare.startLoadingMiddleware;
exports.endLoadingMiddleware = _loadingMiddleWare.endLoadingMiddleware;